module.exports = __webpack_public_path__ + "static/media/team-daniele.b976837c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/team-daniele.jpg
 ** module id = 447
 ** module chunks = 0
 **/